<script>
import { isEqual } from 'lodash-es';

export default {
  name: 'AppTableColumn',
  inject: ['$table'],
  props: {
    header: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    sortBy: {
      type: Object,
      validator: (sortBy) => !sortBy.field || [null, 'desc', 'asc'].includes(sortBy.direction),
    },
    name: {
      type: String,
      default: '',
    },
    cellClasses: {
      type: [String, Object, Array],
      default: '',
    },
    colClasses: {
      type: [String, Object, Array],
      default: '',
    },
    headerClasses: {
      type: [String, Object, Array],
      default: '',
    },
    headerTooltip: {
      type: String,
      default: '',
    },
    headerTooltipType: {
      type: String,
      default: 'info',
    },
    headerTooltipSize: {
      type: Number,
      default: 16,
    },
    headerTooltipClasses: {
      type: String,
      default: null,
    },
    headerDropdown: {
      type: Boolean,
      default: false,
    },
    headerDropdownExtraClasses: {
      type: String,
      default: '',
    },
    headerDropdownFields: {
      type: Object,
      default: () => ({}),
    },
    headerDropdownComponent: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Parents rebuild `sortBy` on every render (same value, fresh reference). AppTable reads the
      // column's sort descriptor DURING its own render while also rendering the slot that recreates
      // these columns, so an unstable reference makes AppTable re-trigger itself forever ("Maximum
      // recursive updates exceeded"). Expose a value-stable copy — updated only on a real change —
      // and let AppTable read THIS instead of the raw prop.
      stableSortBy: this.sortBy,
    };
  },
  watch: {
    sortBy(value) {
      if (!isEqual(this.stableSortBy, value)) {
        this.stableSortBy = value;
      }
    },
  },
  created() {
    this.$table.registerColumn(this);
  },
  render() {
    return null;
  },
};
</script>
